// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { ticketSchema } from '@/ticket/api/types';
import { z } from 'zod';

const closeTicketResponseSchema = z
  .object({
    data: ticketSchema,
    metadata: responseMetadataSchema,
  })
  .transform(({ data, ...response }) => ({ ...response, ticket: data }));

type CloseTicketResponse = z.infer<typeof closeTicketResponseSchema>;

export interface CloseTicketParameters {
  closeReason?: string;
  closedOnBehalfOf?: string;
  closedOn?: string;
}

/**
 * Updates an existing project in the remote API.
 *
 * @param parameters.customerId - The ID of the customer associated with the
 * project.
 * @param parameters.locationIds - The IDs of the locations associated with the
 * project.
 */
export async function closeTicket(
  key: string,
  parameters: CloseTicketParameters
): Promise<CloseTicketResponse> {
  const url = `/v1/ticket/${key}/close`;
  const response = await api.post(url, {
    ...parameters,
  });

  return parseResponse(closeTicketResponseSchema, response.data, {
    schemaName: 'CloseTicket',
    endpoint: url,
  });
}
